import { Component, OnInit } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Router } from '@angular/router';
import { AuthService } from './shared/services/auth.service';
import { SocketService } from './shared/services/socket.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: false,
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  sidenavMode: 'side' | 'over' = 'side';

  constructor(
    private breakpointObserver: BreakpointObserver,
    public auth: AuthService,
    private router: Router,
    private socketService: SocketService
  ) {}

  ngOnInit() {
    this.socketService.conectar();

    this.breakpointObserver
      .observe([Breakpoints.Handset])
      .subscribe((result) => {
        if (result.matches) {
          this.sidenavMode = 'side'; //Cambio a over en caso de que hinchen los huevos
        } else {
          this.sidenavMode = 'side';
        }
      });
  }

  goToProfile() {}

  logout() {
    this.auth.logout();
    this.router.navigate(['/login']);
  }
}
